import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import logger from 'src/logger';
import Loading from '../Loading';
import appendQueryParams from 'src/common/utils/append-query-params';

import './MentionMe.scss';

class MentionMe extends React.Component {
  constructor() {
    super();
    this.observer = null;
    this.state = {
      mentionMeScriptIsLoaded: false
    };
  }

  componentDidMount() {
    let { situation, type, id, country, implementation } = this.props;

    switch (true) {
      case (!situation):
        logger.error(new Error(`Missing prop "situation" in parent component`));
        break;
      case (!type):
        logger.error(new Error(`Missing prop "type" in parent component`));
        break;
      case (!id):
        logger.error(new Error(`Missing prop "id" in parent component`));
        break;
      case (!country):
        logger.error(new Error(`Missing prop "country" in parent component`));
        break;
      case (!implementation):
        logger.error(new Error(`Missing prop "implementation" in parent component`));
        break;
    }
    if (!situation || !type || !id || !country) {
      return null;
    }

    const locale = country.contentLocales[0].split('-').map((countryCode, idx) => idx === 1 ? countryCode.toUpperCase() : countryCode).join('_');

    const mentionMeScriptId = `mention-me-${type}-script`;
    const mentionMeURL = get(window, 'model.topology.mentionMe.endpoint');
    const mentionMeId = get(window, 'model.topology.mentionMe.id');
    const src = appendQueryParams({
      implementation,
      situation,
      locale
    }, `${mentionMeURL}/${type}/${mentionMeId}?`);

    let script = document.getElementById(mentionMeScriptId);

    if (!script && mentionMeURL && mentionMeId) {
      script = document.createElement('script');
      script.id = mentionMeScriptId;
      script.src = src;
      script.async = true;

      document.body.appendChild(script);
    }

    const mentionMeTag = document.getElementById(id);

    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: true
    };

    const callback = mutationList => {
      for (let mutation of mutationList) {
        if (mutation.type === 'childList' && !this.mentionMeScriptIsLoaded) {
          this.setState({
            mentionMeScriptIsLoaded: true
          });
        }
      }
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(mentionMeTag, observerConfig);
  }

  componentWillUnmount() {
    this.observer && this.observer.disconnect();
  }

  render() {
    return (
      <Fragment>
        {!this.state.mentionMeScriptIsLoaded && this.props.children}
        {!this.state.mentionMeScriptIsLoaded && this.props.showLoader ? <Loading relative dark /> : null}
        <div
          ref={this.mentionMeId}
          id={this.props.id}
          className={cx(`mention-me mention-me--${this.props.type} padded-wrapper`, {
            'mention-me--loaded': this.state.mentionMeScriptIsLoaded,
            [this.props.className]: !!this.props.className
          })}
        />
      </Fragment>
    );
  }
}

MentionMe.defaultProps = {
  showLoader: false
};

MentionMe.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  situation: PropTypes.string,
  country: PropTypes.shape({
    contentLocales: PropTypes.array.isRequired
  }),
  implementation: PropTypes.string,
  showLoader: PropTypes.bool
};

export default MentionMe;



// WEBPACK FOOTER //
// ./src/client/js/view/components/MentionMe/MentionMe.js